import { QueryObserverOptions, useQuery } from "react-query";
import { API_URL, APIError, APIResponse, get } from "../api";
import { VirtualAccount } from "../@types";

function useVirtualAccount(
  options?: QueryObserverOptions<APIResponse<VirtualAccount>, APIError>
) {
  const {
    data: virtualAccount,
    isError,
    error,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery<APIResponse<VirtualAccount>, APIError>(
    "virtual-account",
    async () =>
      await get(API_URL + "/account/user/get-virtual-account", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    virtualAccount,
    isError,
    error,
    isLoading,
    refetch,
    isRefetching,
  };
}

export default useVirtualAccount;
